import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router-dom'
import { resolveSeo, SITE_NAME } from '../lib/seo'

// Per-page document head. Mounted once globally (App) to apply the route→meta
// map to every marketing page, and rendered again with explicit props on
// dynamic pages (blog posts, cert programmes) to override title/description.
//
// react-helmet-async merges nested Helmets, with the DEEPEST/last-rendered
// winning per tag — so a page-level <Seo title=… /> overrides the global one.
export default function Seo(props) {
  const { pathname } = useLocation()
  const { title, description, image, canonical, noindex, type } = resolveSeo(pathname, props)

  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  )
}
